import { useEffect, useState }      from 'react';
import { useParams }                from 'react-router-dom';
import View                         from '@widesk-ui/components/View';
import Box                          from '@widesk-ui/components/Box';
import Title                        from '@widesk-ui/components/Title';
import Spin                         from '@widesk-ui/components/Spin';
import Alert                        from '@widesk-ui/components/Alert';
import Button                       from '@widesk-ui/components/Button';
import useTheme                     from '@widesk-ui/hooks/useTheme';
import useDidMount                  from '@widesk-core/hooks/useDidMount';
import { useAuth }                  from '@widesk-ui/hooks/useAuth';
import getTextAndTranslateFromError from '@widesk-core/tools/getTextAndTranslateFromError';
import EmailChangeValidateModel     from '@/models/services/account/EmailChangeValidateModel';

type ValidationState = 'loading' | 'success' | 'error';

export default function ValidateEmailChangePage() {
	const theme = useTheme();
	const { token } = useParams();
	const { logout } = useAuth();

	const [state, setState] = useState<ValidationState>('loading');
	const [errorMessage, setErrorMessage] = useState('');
	const [newEmail, setNewEmail] = useState('');

	useDidMount(() => document.title = 'Confirmation de votre nouvelle adresse e-mail');

	useEffect(() => {
		(async () => {
			try {
				const validate = new EmailChangeValidateModel();
				await validate.patch({ token });

				setNewEmail(validate.newEmail);
				setState('success');
			} catch (e: any) {
				// Le lien est valide mais associé à un autre compte que celui actuellement connecté.
				const message = e?.response?.status === 403
					? 'Ce lien est associé à un autre compte. Merci de vous reconnecter avec le bon compte pour le valider.'
					: (getTextAndTranslateFromError(e) || 'Ce lien de confirmation est invalide ou a expiré.');

				setErrorMessage(message);
				setState('error');
			}
		})();
	}, []);

	return (
		<View heightF center gap="lg">
			<Box style={{ width: 460, padding: theme.marginLG }}>
				<View gap="xxl" center style={{ textAlign: 'center' }}>
					<Title size={theme.fontSizeHeading2}>Confirmation de votre adresse e-mail</Title>

					{state === 'loading' && (
						<Spin size="large" tip="Validation en cours..." />
					)}

					{state === 'success' && (
						<Alert
							type="success"
							message="Votre adresse e-mail a bien été mise à jour"
							description={`Vous pouvez désormais vous connecter avec ${newEmail}.`}
						/>
					)}

					{state === 'error' && (
						<Alert
							type="error"
							message="Problème lors de la confirmation"
							description={errorMessage}
						/>
					)}

					{state !== 'loading' && (
						<Button type="primary" onClick={() => logout()}>Connectez-vous</Button>
					)}
				</View>
			</Box>
		</View>
	);
}
